import {
    chainWalk,
    getAPIGatewayPostRequest,
    getNodeId, isResponseCode5xx,
    logOperationalMetric,
} from "../../../util/Util";
import {
    ENDPOINT_GET_LED_CONTROLLERS,
    LED_CONTROLLER_ASSET_TYPE,
    LED_CONTROLLER_TYPE_CONFIG,
    ENDPOINT_GET_SITE_ASSET_CONFIG,
    LOADING_FAILED,
    AISLE_TYPE_CONFIG,
    ALERT_ADD_ASSET_MESSAGE,
    ALERT_UPDATE_SUCCESS_ASSET_MESSAGE,
    ENDPOINT_UPDATE_DISABLE_MONITORING_SCHEDULE,
    ALERT_UPDATE_ASSET_MESSAGE,
    ENDPOINT_UPDATE_LED_CONTROLLERS_REMARKS,
    ENDPOINT_SET_ASSET_DEFAULTS,
    ALERT_UPDATE_SUCCESS_ASSET_DEFAULTS_MESSAGE,
    ALERT_UPDATE_ASSET_DEFAULTS_MESSAGE,
    ALERT_DELETE_SUCCESS_ASSET_MESSAGE,
    ALERT_DELETE_ASSET_MESSAGE,
    ENDPOINT_GET_ASSET_V2,
    ENDPOINT_BATCH_UPDATE_ASSET_V2,
    ALERT_PAGE_REFRESH_MESSAGE,
    ALERT_CREATE_SUCCESS_ASSET_MESSAGE,
    MAX_RETRIES,
    POLLING_INTERVAL
} from "../../../util/Constants";
import {addAssetV2, getSiteDevicesConnectivity} from "../../../resources/AssetResource";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";
import {PATTERNS} from "../../../util/Validations";
import {
    setAssetStatus
} from "../../../resources/AssetResource";
import {isAssetCreated, isAssetStatusUpdated} from "../../../util/LEDControllerUtil";
import {fetchLatestDataWithRetry} from "../../../util/RetryLogic";
export const metricProcessName = "LED_CONTROLLER_DEVICE_DETAILS";

export const extractLedControllerDeviceList = (nodeId, result, ledControllersConnectivity) => {
    const model = {
        ledControllerDeviceInformation: {},
        selectedDefaultValues: {}
    }
    if (result.status === 200) {
        if (result.data.ledControllerList) {
            result.data.ledControllerList.forEach((ledControllerDeviceDetail) => {
                const detail = ledControllersConnectivity[ledControllerDeviceDetail.mac];
                model.ledControllerDeviceInformation[ledControllerDeviceDetail.mac] = {
                    mac: ledControllerDeviceDetail.mac,
                    ip: ledControllerDeviceDetail.ip,
                    connectivity: detail ? detail.status : LOADING_FAILED,
                    timestamp: detail ? detail.lastUpdateTime : "",
                    location: ledControllerDeviceDetail.location ? ledControllerDeviceDetail.location : "Not Configured",
                    startTime: ledControllerDeviceDetail.disableMonitoring ? ledControllerDeviceDetail.disableMonitoring.startTime : "0",
                    endTime: ledControllerDeviceDetail.disableMonitoring ? ledControllerDeviceDetail.disableMonitoring.endTime : "0",
                    reason: ledControllerDeviceDetail.disableMonitoring ? ledControllerDeviceDetail.disableMonitoring.reason : "",
                    remarks: ledControllerDeviceDetail.remarks ? ledControllerDeviceDetail.remarks : ""
                }
            });
        }
        if (result.data.defaultValues) {
            model.selectedDefaultValues = result.data.defaultValues;
        }
    }
    return model;
}

async function fetchLedControllerDeviceStatusDetails(dispatcher, showCustomAlert, isDataUpdated, ...isDataUpdatedArgs) {

    await fetchLatestDataWithRetry({
        fetchFn: () => callGetLedControllerDeviceDetails(dispatcher),
        conditionFn: (result) => isDataUpdated(result.ledControllerDeviceInformation, ...isDataUpdatedArgs),
        onSuccess: (result) => dispatchLedControllerDeviceStatusDetails(dispatcher, result),
        onFailure: (lastResult) => dispatchLedControllerDeviceStatusDetails(dispatcher, lastResult),
        maxRetries: MAX_RETRIES,
        interval: POLLING_INTERVAL,
        onStart: () => showCustomAlert(ALERT_PAGE_REFRESH_MESSAGE),
    });
}


export async function addLedController(dispatcher, state, showCustomAlert) {
    const requestBody = {
        ledControllerConfig: {
            macAddress: state.macAddress.toLowerCase(),
            ...(state.ipAddress && {ipAddress: state.ipAddress}),
            aisleDetails: state.aisleDetails,
            nodeId: getNodeId()
        },
        nodeId: getNodeId(),
        assetType: LED_CONTROLLER_ASSET_TYPE
    }
    await callAddAssetV2(dispatcher, requestBody, showCustomAlert);
}

async function callAddAssetV2(dispatcher, requestBody, showCustomAlert) {
    const startTime = Date.now();
    await setLoadingStatus(dispatcher, true)

    const response = await addAssetV2(requestBody);

    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "addLedControllerAssetV2", true, false);
        showCustomAlert(ALERT_CREATE_SUCCESS_ASSET_MESSAGE);
        await fetchLedControllerDeviceStatusDetails(dispatcher, showCustomAlert, isAssetCreated, requestBody.ledControllerConfig.macAddress);
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "addLedControllerAssetV2", false, isFault);
        showCustomAlert(chainWalk(() => JSON.parse(response.errorResponse.errorMessage).message, ALERT_ADD_ASSET_MESSAGE));
        await setLoadingStatus(dispatcher, false)
    }
}

async function setLoadingStatus(dispatcher, status) {
    dispatcher({ type: 'SET_LOADING', data: {loadingOverview: status} });
}

export async function getAisleTypes(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: LED_CONTROLLER_ASSET_TYPE,
        configName: AISLE_TYPE_CONFIG,
        pageToken: ""
    }
    await callGetAisleTypes(dispatcher, request);
}

async function callGetAisleTypes(dispatcher, request) {
    let availableAisleTypes = [];
    let response;
    const startTime = Date.now();

    do {
        const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_SITE_ASSET_CONFIG);
        response = await getAPIGatewayDataFromParent(args);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getAisleTypes", true, false);
            request.pageToken = (response && response.data && response.data.pageToken) || null;
            availableAisleTypes = [...availableAisleTypes, ...await getAisleTypesFromResponse(response.data)]
        } else {
            const isFault = isResponseCode5xx(response.status)
            logOperationalMetric(startTime, metricProcessName, "getAisleTypes", false, isFault);
        }
    } while (response.status === 200 && response.data.pageToken)

    const modal = {
        aisleTypes: new Set(availableAisleTypes)
    }
    dispatcher({type: "RECEIVE_AISLE_TYPES", data: modal});
}

async function getAisleTypesFromResponse(response) {
    const aisleTypes = [];
    if (response && response.configItems) {
        response.configItems.forEach(configItem =>
            aisleTypes.push(configItem)
        )
    }
    return aisleTypes;
}

export async function getLedControllerTypes(dispatcher){
    const request = {
        nodeId: getNodeId(),
        assetType: LED_CONTROLLER_ASSET_TYPE,
        configName: LED_CONTROLLER_TYPE_CONFIG
    }
    await callGetLedControllerTypes(dispatcher, request);
}

async function callGetLedControllerTypes(dispatcher, request) {
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_SITE_ASSET_CONFIG);
    const response = await getAPIGatewayDataFromParent(args);

    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getLedControllerTypes", true, false);
        const modal = await getLedControllerTypesFromResponse(response.data)
        dispatcher({type: "RECEIVE_LED_CONTROLLER_TYPES", data: modal});
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "getLedControllerTypes", false, isFault);
    }
}

export async function getLedControllerTypesFromResponse(response) {
    const modal = {
        ledControllerTypes: []
    }
    if (response && response.configItems) {
        response.configItems.forEach(configItem =>
            modal.ledControllerTypes.push(configItem)
        )
    }
    return modal;
}

async function dispatchLedControllerDeviceStatusDetails(dispatcher, model) {
    dispatcher({type: "RECEIVE_DATA", data: model});
    await setLoadingStatus(dispatcher, false)
}

export async function getLedControllerDeviceStatusDetails(dispatcher) {
    const model = await callGetLedControllerDeviceDetails()
    dispatchLedControllerDeviceStatusDetails(dispatcher, model)
}

async function callGetLedControllerDeviceDetails() {
    const request = {
        nodeId: getNodeId()
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_LED_CONTROLLERS);
    let model = {};
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getLedControllerDeviceStatusDetails", true, false);
        const ledControllersConnectivity = await getLEDControllersConnectivity(request.nodeId, response);
        model = extractLedControllerDeviceList(request.nodeId, response, ledControllersConnectivity)
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "getLedControllerDeviceStatusDetails", false, isFault);
    }
    return model;
}

async function getLEDControllersConnectivity(nodeId, result) {
   const deviceIdentifierList = [];
   let ledControllersConnectivity = {};
    if (result.data && result.data.ledControllerList) {
        result.data.ledControllerList.forEach((ledControllerDeviceDetail) => {
            deviceIdentifierList.push(ledControllerDeviceDetail.mac);
        });
    }
    if (deviceIdentifierList && deviceIdentifierList.length > 0) {
        ledControllersConnectivity = await getSiteDevicesConnectivity(nodeId, LED_CONTROLLER_ASSET_TYPE);
    }
    const ledControllerConnectivityMap = {}
    if (ledControllersConnectivity.status === 200 && ledControllersConnectivity.data.deviceConnectivityList) {
        ledControllersConnectivity.data.deviceConnectivityList.forEach(connectivity => {
            const identifier = connectivity.identifier.match(PATTERNS.MAC_MASK)[0];
            ledControllerConnectivityMap[identifier] = connectivity;
        })
    }
    return ledControllerConnectivityMap;
}

export async function setLEDControllerDisableMonitoringData(dispatch, stateValues, mac) {
    const request = {
        nodeId: getNodeId(),
        macAddress: mac,
        startTime: stateValues.startTime,
        endTime: stateValues.endTime,
        reason: stateValues.reason
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_UPDATE_DISABLE_MONITORING_SCHEDULE);
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "updateLEDControllerDisableMonitoringSchedule", true, false);
        setTimeout(async()=> {
            await getLedControllerDeviceStatusDetails(dispatch);
            dispatch({type: 'SET_MONITORING_STATUS_LOADER', data: {mac: mac, monitoringStatusLoading: false}})
        },30000);
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "updateLEDControllerDisableMonitoringSchedule", false, isFault);
    }
}

export async function updateLedControllerStatus(dispatcher, mac, assetType, status, showCustomAlert) {
    const assetLabel = {
        type: "MAC_ADDRESS",
        value: mac
    };
    await callSetAssetStatus(dispatcher, assetLabel, status, assetType, showCustomAlert);
}

async function callSetAssetStatus(dispatcher, assetLabel, status, assetType, showCustomAlert) {
    const startTime = Date.now();
    await setLoadingStatus(dispatcher, true)

    const response = await setAssetStatus(assetLabel, status, getNodeId(), assetType);

    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "setLedControllerAssetStatus", true, false);
        showCustomAlert(ALERT_DELETE_SUCCESS_ASSET_MESSAGE);
        await fetchLedControllerDeviceStatusDetails(dispatcher, showCustomAlert, isAssetStatusUpdated, assetLabel.value);
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "setLedControllerAssetStatus", false, isFault);
        showCustomAlert(chainWalk(() => JSON.parse(response.errorResponse.errorMessage).message, ALERT_DELETE_ASSET_MESSAGE));
        await setLoadingStatus(dispatcher, false)
    }
}

export async function postUpdatedRemarkToDevice(device, newRemark, dispatch) {
    const request = {
        nodeId : getNodeId(),
        macAddress: device.mac,
        remarks: newRemark
    }
    const args = getAPIGatewayPostRequest(request, ENDPOINT_UPDATE_LED_CONTROLLERS_REMARKS);
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status !== 200) {
        alert(ALERT_UPDATE_ASSET_MESSAGE);
        dispatch({type: 'LOAD_VIEW', data: {dispatcher: dispatch}});
    }
}

export async function setDefaultValues(dispatcher, defaultValues, showCustomAlert) {
    const request = {
        ledControllerDefaultValues: defaultValues.ledControllerDefaultValues,
        nodeId: getNodeId(),
        assetType: LED_CONTROLLER_ASSET_TYPE
    }
    await callSetDefaultValues(dispatcher, request, showCustomAlert);
}

async function callSetDefaultValues(dispatcher, request, showCustomAlert) {
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_SET_ASSET_DEFAULTS);
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "setLedControllerAssetDefaults", true, false);
        await getLedControllerDeviceStatusDetails(dispatcher);
        showCustomAlert(ALERT_UPDATE_SUCCESS_ASSET_DEFAULTS_MESSAGE);
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "setLedControllerAssetDefaults", false, isFault);
        showCustomAlert(chainWalk(() => JSON.parse(response.errorResponse.errorMessage).message, ALERT_UPDATE_ASSET_DEFAULTS_MESSAGE));
    }
}

export async function getLedControllerAssetDetail(dispatcher, macAddress) {
    const request = {
        nodeId: getNodeId(),
        assetType: LED_CONTROLLER_ASSET_TYPE,
        deviceName: macAddress
    }
    await callGetAssetV2(dispatcher, request);
}

async function callGetAssetV2(dispatcher, request) {
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_ASSET_V2);
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getLedControllerAssetV2", true, false);
        dispatcher({type: "RECEIVE_ASSET_DETAIL", data: response.data.ledControllerConfig});
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "getLedControllerAssetV2", false, isFault);
    }
}

export async function updateLedControllerAssetData(dispatcher, mac, aisleDetails, showCustomAlert) {
    const request = {
        ledControllerConfigList: [
            {
                macAddress: mac,
                nodeId: getNodeId(),
                aisleDetails: aisleDetails
            }
        ],
        assetType: LED_CONTROLLER_ASSET_TYPE,
        nodeId: getNodeId()
    }
    await callBatchUpdateAssetV2(dispatcher, request, showCustomAlert);
}

async function callBatchUpdateAssetV2(dispatcher, request, showCustomAlert) {
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_BATCH_UPDATE_ASSET_V2);
    const response = await getAPIGatewayDataFromParent(args); //{status: 200}
    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "updateLedControllerAssetV2", true, false);
        await getLedControllerAssetDetail(dispatcher, request.macAddress);
        showCustomAlert(ALERT_UPDATE_SUCCESS_ASSET_MESSAGE);
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "updateLedControllerAssetV2", false, isFault);
        showCustomAlert(chainWalk(() => JSON.parse(response.errorResponse.errorMessage).message, ALERT_UPDATE_ASSET_MESSAGE));
    }
}

export async function getLedControllerDevices(dispatcher) {
    const request = {
        nodeId: getNodeId()
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_LED_CONTROLLERS);
    const response = await getAPIGatewayDataFromParent(args);

    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getLedControllerMacAddresses", true, false);
        const model = await extractLedControllerMetadata(response)
        dispatcher({type: "RECEIVE_DEVICES", data: model});
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "getLedControllerMacAddresses", false, isFault);
    }
}

async function extractLedControllerMetadata(response) {
    let ledDevicesResponse = {
        ledDevices: {},
        ledControllerType: response.data && response.data.defaultValues ?
            response.data.defaultValues.ledControllerType : null
    }
    if (response.data  && response.data.ledControllerList) {
        response.data.ledControllerList.forEach((ledDetail) => {
            ledDevicesResponse.ledDevices[ledDetail.mac] = {
                mac: ledDetail.mac,
                name: ledDetail.name,
                location: ledDetail.location
            }
        });
    }
    return ledDevicesResponse;
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/network/LEDControllerOverviewNetworkAPI.js